module.exports = __webpack_public_path__ + "static/media/iconTwo.19a162b9.svg";